import CheckIcon from "@material-ui/icons/Check";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";

import BaseDataTable from "../../../../../components/modules/BaseDataTable";
import Button from "../../../../../components/elements/Button";
import DomainList from "../DomainList";
import classes from "../../PublicationListSelectionSlide.module.scss";
import { PublicDomainList } from "../../../../../types/campaignTypes";
import { truncateText } from "../../../../../helpers/truncateText";

type PublicDomainListsDashboardProps = {
  publicDomainLists: PublicDomainList[];
  selectedDomainListsIds: number[];
  toggleSelectDomainLists: (beeswaxListId: number) => void;
};

const PublicDomainListsDashboard: FC<PublicDomainListsDashboardProps> = ({
  publicDomainLists,
  selectedDomainListsIds,
  toggleSelectDomainLists,
}) => {
  const columns = [
    { key: "name", label: "Name", minWidth: 400 },
    { key: "actions", label: "Actions", minWidth: 100 },
  ] as const;

  const rows = publicDomainLists
    .sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
    .map(({ beeswaxListId, name, publicPublications }) => {
      const isSelected = selectedDomainListsIds.includes(beeswaxListId);

      return {
        id: beeswaxListId.toString(),
        name: (() => (
          <Tooltip title={name}>
            <Typography>{truncateText(name, 100)}</Typography>
          </Tooltip>
        ))(),
        actions: (() => (
          <Button
            className={classes.selectButton}
            variant={isSelected ? "contained" : "outlined"}
            onClick={() => toggleSelectDomainLists(beeswaxListId)}
          >
            {isSelected ? "Selected" : "Select"}
            <CheckIcon />
          </Button>
        ))(),
        collapsableConfigs: {
          collapsable: true,
          collapsableChild: <DomainList domainList={publicPublications} />,
        },
      };
    });

  return (
    <div className={classes.domainListsDashboardContainer}>
      <div className={classes.header}>
        <Typography variant="h2">BrandGen Publication Lists</Typography>
        <Typography>
          These are carefully curated lists of publications that we believe have a high likelihood of accepting ad
          traffic. If you do not wish to use any of these lists, you can create your own custom list instead.
        </Typography>
      </div>

      <BaseDataTable columns={columns} rows={rows} />
    </div>
  );
};

export default PublicDomainListsDashboard;
